import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter } from "react-router-dom";

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
} from "reactstrap";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

import Breadcrumbs from "components/Common/Breadcrumb";

import {
  getSchemelist,
  updateSchemeList,
  addStock,
  getStockList,
} from "store/scheme/actions";

import "assets/scss/table.scss";

const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

// Formats a yyyy-mm-dd date string as DD-MMM-YY (e.g. "05-Oct-26").
// Parsed manually (no Date object) so timezones can never shift the day.
const formatExpiryDate = (dateStr) => {
  if (!dateStr) return "-";

  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(dateStr));

  if (!match) return dateStr;

  const [, year, month, day] = match;
  const monthName = MONTHS[Number(month) - 1];

  if (!monthName) return dateStr;

  return `${day}-${monthName}-${year.slice(-2)}`;
};

class ReagentsList extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.state = {
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
      modal: false,
      ReagentsListColumns: [
        {
          dataField: "name",
          text: "Scheme Name",
          sort: true,
          style: { textAlign: "left" },
        },
        {
          dataField: "lot_no",
          text: "Lot No",
          sort: true,
          style: { textAlign: "center" },
          headerStyle: { textAlign: "center" },
        },
        {
          dataField: "expiry_date",
          text: "Expiry Date",
          sort: true,
          style: { textAlign: "center" },
          headerStyle: { textAlign: "center" },
          formatter: (cell) => formatExpiryDate(cell),
        },
        {
          dataField: "quantity",
          text: "Quantity",
          sort: true,
          style: { textAlign: "center" },
          headerStyle: { textAlign: "center" },
        },
        {
          dataField: "action",
          isDummyField: true,
          editable: false,
          text: "Action",
          style: { textAlign: "center" },
          headerStyle: { textAlign: "center" },
          formatter: (cellContent, row) => (
            <div className="d-flex gap-3 justify-content-center">
              <i
                className="mdi mdi-pencil font-size-18 text-primary"
                style={{ cursor: "pointer" }}
                title="Update"
                onClick={() => this.handleSaveRow(row)}
              />
            </div>
          ),
        },
      ],
    };
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    const { onGetScheme, onGetStock } = this.props;
    // Fetch Scheme list to populate the dropdown
    onGetScheme(this.state.user_id);
    // Fetch existing stock entries
    onGetStock(this.state.user_id);
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  handleSaveRow = (row) => {
    const { onUpdateScheme, onGetStock } = this.props;

    const updatedScheme = {
      id: row.id,
      name: row.name,
      lot_no: row.lot_no,
      expiry_date: row.expiry_date,
      quantity: row.quantity,
    };

    onUpdateScheme(updatedScheme);
    setTimeout(() => {
      onGetStock(this.state.user_id);
    }, 1000);
  };

  render() {
    const { SchemeList, StockList } = this.props;
    const { modal } = this.state;

    // Defensive defaults: StockList/SchemeList can be undefined on the
    // very first render, before onGetStock/onGetScheme's API calls
    // resolve — reading .length or .map on undefined here was crashing
    // the whole page render.
    const schemeList = Array.isArray(SchemeList) ? SchemeList : [];
    const stockList = Array.isArray(StockList) ? StockList : [];

    const pageOptions = {
      sizePerPage: 50,
      totalSize: stockList.length,
      custom: true,
    };

    const defaultSorted = [
      {
        dataField: "id",
        order: "desc",
      },
    ];

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Stock In | NEQAS</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs title="Stock" breadcrumbItem="Stock In" />
            <Row className="justify-content-center">
              <Col lg="12">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={this.state.ReagentsListColumns}
                      data={stockList}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <React.Fragment>
                          <Row className="mb-4">
                            <Col xl="12">
                              <div className="text-sm-end">
                                <Button
                                  style={{ background: "#0000CD" }}
                                  className="font-16 btn-block btn btn-primary"
                                  onClick={this.toggle}
                                >
                                  <i className="mdi mdi-plus-circle-outline me-1" />
                                  Add Stock
                                </Button>
                              </div>
                            </Col>
                          </Row>
                          <Row className="mb-4">
                            <Col xl="12">
                              <div className="table-responsive">
                                <BootstrapTable
                                  keyField="id"
                                  columns={this.state.ReagentsListColumns}
                                  data={stockList}
                                  {...paginationTableProps}
                                  defaultSorted={defaultSorted}
                                  classes={"table align-middle table-hover"}
                                  bordered={false}
                                  striped={true}
                                  headerWrapperClasses={"table-light"}
                                  responsive
                                  ref={this.node}
                                />

                                <Modal isOpen={modal} className={this.props.className}>
                                  <ModalHeader toggle={this.toggle} tag="h4">
                                    Add Stock
                                  </ModalHeader>
                                  <ModalBody>
                                    <Formik
                                      enableReinitialize={true}
                                      initialValues={{
                                        scheme_id: "",
                                        lot_no: "",
                                        expiry_date: "",
                                        quantity: "",
                                      }}
                                      validationSchema={Yup.object().shape({
                                        scheme_id: Yup.string().required(
                                          "Please select a scheme"
                                        ),
                                        lot_no: Yup.string()
                                          .trim()
                                          .required("Please enter Lot No"),
                                        expiry_date: Yup.date().required(
                                          "Please enter Expiry Date"
                                        ),
                                        quantity: Yup.number()
                                          .typeError("Quantity must be a number")
                                          .required("Please enter Quantity"),
                                      })}
                                      onSubmit={(values, { resetForm }) => {
                                        const { onAddStock, onGetStock } = this.props;
                                        const selectedScheme = schemeList.find(
                                          (s) => String(s.id) === String(values.scheme_id)
                                        );

                                        const newStock = {
                                          scheme_id: values.scheme_id,
                                          name: selectedScheme
                                            ? selectedScheme.name
                                            : "",
                                          lot_no: values.lot_no,
                                          expiry_date: values.expiry_date,
                                          quantity: values.quantity,
                                          added_by: this.state.user_id,
                                        };

                                        onAddStock(newStock, this.state.user_id);
                                        setTimeout(() => {
                                          onGetStock(this.state.user_id);
                                        }, 1000);

                                        resetForm();
                                        this.toggle();
                                      }}
                                    >
                                      {({ errors, touched }) => (
                                        <Form>
                                          <Row>
                                            <Col className="col-12">
                                              <div className="mb-3">
                                                <Label className="form-label">
                                                  Scheme
                                                  <span className="text-danger">*</span>
                                                </Label>
                                                <Field
                                                  as="select"
                                                  name="scheme_id"
                                                  className={
                                                    "form-control" +
                                                    (errors.scheme_id &&
                                                    touched.scheme_id
                                                      ? " is-invalid"
                                                      : "")
                                                  }
                                                >
                                                  <option value="">
                                                    ----- Please select -----
                                                  </option>
                                                  {/* Scheme dropdown populated from SchemeList prop */}
                                                  {schemeList.map((scheme) => (
                                                    <option
                                                      key={scheme.id}
                                                      value={scheme.id}
                                                    >
                                                      {scheme.name}
                                                    </option>
                                                  ))}
                                                </Field>
                                                <ErrorMessage
                                                  name="scheme_id"
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                              </div>

                                              <div className="mb-3">
                                                <Label className="form-label">
                                                  Lot No
                                                  <span className="text-danger">*</span>
                                                </Label>
                                                <Field
                                                  name="lot_no"
                                                  type="text"
                                                  className={
                                                    "form-control" +
                                                    (errors.lot_no && touched.lot_no
                                                      ? " is-invalid"
                                                      : "")
                                                  }
                                                />
                                                <ErrorMessage
                                                  name="lot_no"
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                              </div>

                                              <div className="mb-3">
                                                <Label className="form-label">
                                                  Expiry Date
                                                  <span className="text-danger">*</span>
                                                </Label>
                                                <Field
                                                  name="expiry_date"
                                                  type="date"
                                                  className={
                                                    "form-control" +
                                                    (errors.expiry_date &&
                                                    touched.expiry_date
                                                      ? " is-invalid"
                                                      : "")
                                                  }
                                                />
                                                <ErrorMessage
                                                  name="expiry_date"
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                              </div>

                                              <div className="mb-3">
                                                <Label className="form-label">
                                                  Quantity
                                                  <span className="text-danger">*</span>
                                                </Label>
                                                <Field
                                                  name="quantity"
                                                  type="number"
                                                  className={
                                                    "form-control" +
                                                    (errors.quantity &&
                                                    touched.quantity
                                                      ? " is-invalid"
                                                      : "")
                                                  }
                                                />
                                                <ErrorMessage
                                                  name="quantity"
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col>
                                              <div className="text-end">
                                                <button
                                                  type="submit"
                                                  className="btn btn-success save-user"
                                                  style={{
                                                    backgroundColor: "#0000CD",
                                                    borderColor: "#0000CD",
                                                  }}
                                                >
                                                  Save
                                                </button>
                                              </div>
                                            </Col>
                                          </Row>
                                        </Form>
                                      )}
                                    </Formik>
                                  </ModalBody>
                                </Modal>
                              </div>
                            </Col>
                          </Row>
                          <Row className="align-items-md-center mt-30">
                            <Col className="pagination pagination-rounded justify-content-end mb-2">
                              <PaginationListStandalone {...paginationProps} />
                            </Col>
                          </Row>
                        </React.Fragment>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

ReagentsList.propTypes = {
  match: PropTypes.object,
  SchemeList: PropTypes.array,
  StockList: PropTypes.array,
  className: PropTypes.any,
  onGetScheme: PropTypes.func,
  onGetStock: PropTypes.func,
  onUpdateScheme: PropTypes.func,
  onAddStock: PropTypes.func,
};

// Both SchemeList and StockList come from the single "SchemeList" reducer slice
const mapStateToProps = ({ SchemeList }) => ({
  SchemeList: SchemeList.SchemeList,
  StockList: SchemeList.StockList,
});

const mapDispatchToProps = (dispatch) => ({
  onGetScheme: (id) => dispatch(getSchemelist(id)),
  onGetStock: (id) => dispatch(getStockList(id)),
  onUpdateScheme: (scheme) => dispatch(updateSchemeList(scheme)),
  onAddStock: (stock, id) => dispatch(addStock(stock, id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReagentsList));